/**
 * preferredOffice — s106 (TestFlight b72, Dr. Rami: "Create an option to send a case - they can start
 * the case workflow and have this provider saved as the doctor selection when they get to the share
 * hub. Needs to work for the docs not current subscribed to orella."; mockup "Orella Doctors Tab
 * Send", approved 2026-10-16).
 *
 * The office a patient chose on the Doctors tab (a directory row from GET /providers/search, not on
 * Orella), kept ON THE PHONE for one case, as 'orella-preferred-doctor' keeps an Orella doctor:
 *   - StartCaseSheet saves it before the case exists (`caseId` empty) or for the case being continued;
 *   - the share hub reads it: an unbound one is BOUND to the first case that reaches the hub, and one
 *     bound to another case is not shown there;
 *   - it is cleared once the case has a current office send, when the patient picks a different office,
 *     or after a day.
 * Nothing is sent to the server until the patient sends the fax (SendReportScreen, with consent).
 * The storage is a parameter so the gate can run these against a plain object.
 */
export const PREFERRED_OFFICE_KEY = 'orella-preferred-office'
const MAX_AGE_MS = 24 * 60 * 60 * 1000

const session = () => {
  try { return typeof window !== 'undefined' ? window.sessionStorage : null } catch (_) { return null }
}

/** The fields the hub and SendReportScreen read; a directory row's own shape. PURE. */
export function officeFromRow(r) {
  if (!r || !r.npi) return null
  return {
    npi: String(r.npi), name: r.name || '', credential: r.credential || null, specialty: r.specialty || null,
    address: r.address || null, phone: r.phone || null, fax: r.fax || null,
    faxOnFile: !!r.faxOnFile, faxSource: r.faxSource || null,
    // s123 (board F): the practice name on file, and "Any clinician at this office" (utils/officeGroups officeSendTarget).
    practice: r.practice || null, anyClinician: r.anyClinician === true,
  }
}

export function savePreferredOffice(row, caseId = '', store = session(), now = Date.now()) {
  const office = officeFromRow(row)
  if (!office || !store) return null
  const rec = { office, caseId: caseId ? String(caseId) : '', savedAt: now }
  try { store.setItem(PREFERRED_OFFICE_KEY, JSON.stringify(rec)) } catch (_) { return null }
  return rec
}

/** The office saved for `caseId`, binding an unbound one to it; null otherwise (and drops a stale one). */
export function readPreferredOffice(caseId, store = session(), now = Date.now()) {
  if (!store || !caseId) return null
  let rec = null
  try { rec = JSON.parse(store.getItem(PREFERRED_OFFICE_KEY) || 'null') } catch (_) { rec = null }
  if (!rec || !rec.office || !rec.office.npi) return null
  if (!Number.isFinite(rec.savedAt) || now - rec.savedAt > MAX_AGE_MS) { clearPreferredOffice(store); return null }
  if (rec.caseId && rec.caseId !== String(caseId)) return null
  if (!rec.caseId) {
    rec = { ...rec, caseId: String(caseId) }
    try { store.setItem(PREFERRED_OFFICE_KEY, JSON.stringify(rec)) } catch (_) { /* shown once */ }
  }
  return rec.office
}

export function clearPreferredOffice(store = session()) {
  try { store && store.removeItem(PREFERRED_OFFICE_KEY) } catch (_) { /* nothing kept */ }
}
